import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Layouts
import MainLayout from './components/layout/MainLayout';
import AuthLayout from './components/layout/AuthLayout';
import DashboardLayout from './components/layout/DashboardLayout';

// Pages
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import VerifyEmail from './pages/auth/VerifyEmail';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Opportunities from './pages/dashboard/Opportunities';
import OpportunityDetail from './pages/dashboard/OpportunityDetail';
import WatchList from './pages/dashboard/WatchList';
import Pipeline from './pages/dashboard/Pipeline';
import Agents from './pages/dashboard/Agents';
import Analytics from './pages/dashboard/Analytics';
import AIAssistant from './pages/dashboard/AIAssistant';
import ProposalWriter from './pages/dashboard/ProposalWriter';
import CRM from './pages/dashboard/CRM';
import Documents from './pages/dashboard/Documents';
import Integrations from './pages/dashboard/Integrations';
import Team from './pages/dashboard/Team';
import Settings from './pages/dashboard/Settings';
import Billing from './pages/dashboard/Billing';
import Pricing from './pages/Pricing';
import Features from './pages/Features';
import About from './pages/About';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public Routes */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/about" element={<About />} />
        </Route>

        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Protected Dashboard Routes */}
        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/opportunities/:id" element={<OpportunityDetail />} />
          <Route path="/watchlist" element={<WatchList />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/ai-assistant" element={<AIAssistant />} />
          <Route path="/proposal-writer" element={<ProposalWriter />} />
          <Route path="/crm" element={<CRM />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/team" element={<Team />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/billing" element={<Billing />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
